export default class RetailersRanging {
  constructor(questions, retailersMpns, debug = false) {
    this.questions = questions;
    this.retailersMpns = retailersMpns;
    this.debug = debug;
  }

  hasProduct(mpn) {
    return mpn && mpn.toLowerCase() in this.retailersMpns;
  }

  getQuestion(id) {
    return this.questions[id];
  }

  performRetailerRanging(retailerDecisionTree) {
    this.debug && console.debug("Original:\n" + this.dumpTree(retailerDecisionTree.question));
    let outcomes = this.workoutRetailerRanging(retailerDecisionTree.question);
    if (outcomes.length === 1) {
      retailerDecisionTree.question = outcomes[0];
    }
    this.debug && console.debug("Pass1:\n" + this.dumpTree(retailerDecisionTree.question));
    let missing = this.fixMissingRecommendations(retailerDecisionTree.question);
    this.debug && console.debug("Result:\n" + this.dumpTree(retailerDecisionTree.question));
    return missing;
  }

  workoutRetailerRanging(question) {
    if (Object.prototype.hasOwnProperty.call(question, 'ref')) {
      //question.question = this.getQuestion(question.ref);
      for (let i = question.outcomes.length - 1; i >= 0; i--) {
        const outcome = question.outcomes[i]
        if (outcome.type === 'question') {
          let childOutcomes = this.workoutRetailerRanging(outcome);
          if (childOutcomes.length === 1) {
            question.outcomes[i] = childOutcomes[0];
          } else if (childOutcomes.length < 1) {
            // Drop entire question
            console.debug(`Dropping question: ${outcome}`);
            question.outcomes.splice(i, 1);
          }
        } else if (outcome.type === 'recommendation') {
          if (!this.hasProduct(outcome.primary.mpn)) {
            outcome.primary = null;
          }
          if (!this.hasProduct(outcome.secondary.mpn)) {
            outcome.secondary = null;
          }
          if (!this.hasProduct(outcome?.third?.mpn)) {
            outcome.third = null;
          }
          // Use secondary recommendation for primary if primary is missing.
          if (outcome.secondary && !outcome.primary) {
            outcome.primary = outcome.secondary;
            outcome.secondary = null;
          }
          // Drop entire outcome
          if (!outcome.secondary && !outcome.primary) {
            console.debug(`Dropping ${outcome}`);
            question.outcomes.splice(i, 1);
          }
        }
      }
      return question.outcomes;
    }
  }

  findCandidate(q, mpn, primaryOnly = true) {
    let found;
    for (let i = 0; i < q.outcomes.length; i++) {
      const o = q.outcomes[i];
      if (o.type === 'recommendation') {
        if (o.primary.mpn !== mpn) {
          return o.primary.mpn;
        } else if (!primaryOnly && o.secondary) {
          if (o.secondary.mpn !== mpn && o.secondary.derived !== true) {
            return o.secondary.mpn;
          }
        }
      } else if (o.type === 'question') {
        found = this.findCandidate(o, mpn, primaryOnly);
        if (found) {
          return found;
        }
      }
    }
    if (!found) {
      for (let i = 0; i < q.outcomes.length; i++) {
        const o = q.outcomes[i];
        if (o.type === 'question') {
          found = this.findCandidate(o, mpn, false);
          if (found) {
            return found;
          }
        }
      }
    }
    return undefined;
  }

  findCandidateAndSet(question, missing) {
    missing.forEach(o => {
      let mpn = this.findCandidate(question, o.primary.mpn, true);
      // mpn && console.debug(`Found primary: ${mpn} when looking for ${o.primary.mpn}`);
      if (!mpn) {
        mpn = this.findCandidate(question, o.primary.mpn, false);
        // mpn && console.debug(`Found secondary: ${mpn} when looking for ${o.primary.mpn}`);
      }
      if (mpn) {
        o.secondary = {
          mpn: mpn,
          derived: true
        };
      }
    });
    return missing.filter(o => !o.secondary)
  }

  fixMissingRecommendations(question, isRoot = true) {
    let missing = [];
    if (Object.prototype.hasOwnProperty.call(question, 'ref')) {
      question.outcomes.forEach(outcome => {
        if (outcome.type === 'question') {
          let missingChildren = this.fixMissingRecommendations(outcome, false);
          this.findCandidateAndSet(question, missingChildren).forEach(i => missing.push(i));
        } else if (outcome.type === 'recommendation') {
          if ((!outcome.primary) || (!outcome.secondary)) {
            missing.push(outcome);
          }
        }
      });
    }
    if (isRoot) {
      return this.findCandidateAndSet(question, missing);
    }
    return missing;
  }

  dumpTree(q, indent = "") {
    if (q.type === 'question') {
      let question = this.getQuestion(q.ref);
      let r = `${indent}Q${q.ref + 1}. ${this.getQuestion(q.ref).question}\n`;
      for (let i = 0; i < q.outcomes.length; i++) {
        const o = q.outcomes[i];
        const c = question.choices[i];
        r = `${r}    ${indent}A${i + 1}. ${c.title}\n`;
        r = r + this.dumpTree(o, indent + "    " + "    ");
      }
      return r;
    } else {
      return `${indent}R1. ${q.primary ? q.primary.mpn : 'n/a'}\n${indent}R2. ${q.secondary ? q.secondary.mpn : 'n/a'}\n`
    }
  }
}
